<template>
  <div />
</template>

<script>
  import {mapGetters} from 'vuex'

  export default {
    name: 'TrackerFacebookPixel',
    data() {
      return {
        eventref: location.search.includes('eventref=fb_oea') ? 'fb_oea' : '',
      }
    },
    computed: {
      ...mapGetters(['config']),
      isEnabled() {
        return this.config.tracking && this.config.facebookPixel
      },
    },
    watch: {
      isEnabled: {
        immediate: true,
        handler() {
          if (this.isEnabled) {
            this.init()
          } else {
            this.destroy()
          }
        },
      }
    },
    methods: {
      init() {
        if (!window.fbq && this.isEnabled) {
          !function(f,b,e,v,n,t,s)
          {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
          n.callMethod.apply(n,arguments):n.queue.push(arguments)};
          if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
          n.queue=[];t=b.createElement(e);t.async=!0;
          t.src=v;s=b.getElementsByTagName(e)[0];
          s.parentNode.insertBefore(t,s)}(window, document,'script',
          'https://connect.facebook.net/en_US/fbevents.js');
          window.fbq('init', this.config.facebookPixel);
          window.fbq('track', 'PageView');
        }
      },
      track(goal, params = {}) {
        if (window.fbq && this.isEnabled) {
          if (goal === 'SETTINGS_PLANS_SUBSCRIBE') {
            window.fbq('track', 'InitiateCheckout', {...params, eventref: this.eventref});
          }
          if (goal === 'USER_SIGNUP_SUCCESS') {
            window.fbq('track', 'CompleteRegistration', {...params, eventref: this.eventref});
          }
        }
      },
      destroy() {

      },
    },
    created() {
      this.$store.subscribeAction(({type, payload}) => {
        if (type === 'goal') {
          this.track(payload.goal, payload.params)
        }
      })
    },
    beforeDestroy() {
      this.destroy()
    },
  }
</script>
